import { render, staticRenderFns } from "./grower-tab.vue?vue&type=template&id=30dbd9be"
import script from "./grower-tab.vue?vue&type=script&lang=js"
export * from "./grower-tab.vue?vue&type=script&lang=js"
import style0 from "./grower-tab.vue?vue&type=style&index=0&id=30dbd9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports